import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { Edit } from "@components/modules/invoices/Create";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationOutgoingInvoice } from "@src/components/widgets/AppSubNav/navigation-invoices/outgoing-invoices";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Edit invoice`}
    navigation={<NavigationOutgoingInvoice invoiceId={id} />}
  >
    <Edit.Outgoing id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/outgoing-invoices/edit")({
  component: RouteComponent,
});
